/** управление данными для сайта
 */
import _ from "lodash";
import React, { useEffect } from "react";
import { Route, Switch, Redirect, useRouteMatch } from "react-router-dom";
import { Error400 } from "views/pages";
import IntlMessages from "util/intlMessages";
import { BreadCrumbs } from "components/standart/PageTitle";

import { path } from "./init";

import Casts from "./Casts";
import { path as castsPath } from "./Casts/init";

import Sources from "./Sources";
import Prompts from "./Prompts";
import Selections from "./Selections";
import { path as sourcesPath } from "./Sources/init";
import { path as selectionsPath } from "./Selections/init";
import { path as promptsPath } from "./Prompts/init";

const Specials = (props) => {
  const { url, path } = useRouteMatch();
  const { breadCrumbs = new BreadCrumbs() } = props;

  breadCrumbs.push({
    title: <IntlMessages id="Specials" />,
    url,
  });
  return (
    <div className="react-strap-doc">
      <Switch>
        <Route path={`${castsPath}`}>
          <Casts {...{ breadCrumbs }} />
        </Route>

        <Route path={`${sourcesPath}`}>
          <Sources {...{ breadCrumbs }} />
        </Route>

        <Route path={`${promptsPath}`}>
          <Prompts {...{ breadCrumbs }} />
        </Route>

        <Route path={`${selectionsPath}`}>
          <Selections {...{ breadCrumbs }} />
        </Route>

        <Route exact path={path} render={() => <Redirect to={`${castsPath}`} />} />

        <Route component={Error400} />
      </Switch>
    </div>
  );
};

export default { path, component: Specials };
